import { render } from "./VerifyView.vue?vue&type=template&id=980a2db0&scoped=true"
import script from "./VerifyView.vue?vue&type=script&lang=js"
export * from "./VerifyView.vue?vue&type=script&lang=js"

import "./VerifyView.vue?vue&type=style&index=0&id=980a2db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-980a2db0"]])

export default __exports__